import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import Delete from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Tooltip from '@material-ui/core/Tooltip';

import Button from '~/components/Button';
import Route from '~/providers/Route';

import useStyles from './styles';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

function PaperButtons({
  id,
  openDropDown,
  setOpenDropDown,
  DropDownActions,
  setModal,
  backRoute,
  newRoute,
  editRoute,
  history,
  setImportFileModal,
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  function handleClick(event) {
    setOpenDropDown(event.currentTarget);
  }

  function handleEdit() {
    history.push(editRoute.reverse({ id }));
  }

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        variant="outlined"
        onClick={() => history.push(backRoute.spec)}
      >
        {t('button-go-back')}
      </Button>
      {newRoute && (
        <Button
          className={classes.button}
          color="success"
          onClick={() => history.push(newRoute.spec)}
        >
          {t('button-menu-new')}
        </Button>
      )}
      {editRoute && (
        <Button
          className={classes.button}
          color="warning"
          onClick={() => handleEdit()}
          endIcon={<Edit />}
        >
          {t('button-menu-edit')}
        </Button>
      )}
      {setModal && (
        <Button
          className={classes.button}
          color="red"
          onClick={() => {
            setModal(true);
          }}
          endIcon={<Delete />}
        >
          {t('button-menu-delete')}
        </Button>
      )}
      {setImportFileModal && (
        <Button
          className={classes.buttonImport}
          onClick={() => setImportFileModal(true)}
        >
          {t('button-menu-import-file')}
        </Button>
      )}

      {DropDownActions && (
        <>
          <Tooltip className={classes.button} title={t('button-menu-actions')}>
            <IconButton onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
          <StyledMenu
            id="actions-menu"
            keepMounted
            anchorEl={openDropDown}
            open={Boolean(openDropDown)}
            onClose={() => setOpenDropDown(null)}
          >
            <DropDownActions />
          </StyledMenu>
        </>
      )}
    </div>
  );
}

PaperButtons.propTypes = {
  id: PropTypes.string.isRequired,
  openDropDown: PropTypes.object,
  setOpenDropDown: PropTypes.func,
  setModal: PropTypes.func,
  backRoute: PropTypes.instanceOf(Route).isRequired,
  editRoute: PropTypes.instanceOf(Route).isRequired,
  setImportFileModal: PropTypes.func,
  DropDownActions: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};
export default withRouter(PaperButtons);
